function isProduction() {
  return process.env.REACT_APP_ENVIROMENT === 'production';
}

export function isLocalDev() {
  return process.env.REACT_APP_ENVIROMENT === 'developmet';
}

let backendUrlPrefix;
let REACT_APP_USER_POOL_ID;
let REACT_APP_USER_POOL_WEB_CLIENT_ID;
let REACT_APP_AWS_REGION;


if (isProduction()) {
  backendUrlPrefix = 'https://api.venn.city/production/node-server';
  REACT_APP_USER_POOL_ID='eu-central-1_mZUYRhATK';
  REACT_APP_USER_POOL_WEB_CLIENT_ID='2n2i5lup94idht5af2r82fn19j';
  REACT_APP_AWS_REGION='eu-central-1';
} else if (isLocalDev()) {
  backendUrlPrefix = 'http://localhost:3000';
  REACT_APP_USER_POOL_ID='eu-central-1_PI1z8a0BW'
  REACT_APP_USER_POOL_WEB_CLIENT_ID='2ej0r3boccj3umebqfahf38nt9'
  REACT_APP_AWS_REGION='eu-central-1'
} else {
  backendUrlPrefix = 'https://api.venn.city/staging/node-server';
  REACT_APP_USER_POOL_ID='eu-central-1_PI1z8a0BW'
  REACT_APP_USER_POOL_WEB_CLIENT_ID='2ej0r3boccj3umebqfahf38nt9'
  REACT_APP_AWS_REGION='eu-central-1'
}

const env = {
  backendUrlPrefix,
  isProduction,
  isLocalDev,
  REACT_APP_USER_POOL_ID,
  REACT_APP_USER_POOL_WEB_CLIENT_ID,
  REACT_APP_AWS_REGION,
  MIXPANEL_CONFIG: {
    DEV_TOKEN: '2140924593374ae8a1ec36d821102eb2',
    PROD_TOKEN: '077954084acbafd8ee56e0a772c3ebaf'
  },
  INTERCOM_CONFIG: {
    DEV_APP_ID: 'b23878qx',
    PROD_APP_ID: 'sp8xufb7'
  },
  PAYMENT_OS_CONFIG: {
    DEV_PUBLIC_KEY: '5df4b061-7387-4db8-89a6-da4311720ca6',
    PROD_PUBLIC_KEY: '47d215fc-9a11-4a88-890a-81790cb67a60'
  },
};

export default env;



// WEBPACK FOOTER //
// ./src/config/env.js